import { useEffect, useState } from "react";
import api from "@/lib/api";
import { CheckCircle2, Loader2, Circle } from "lucide-react";

const STYLE = {
  "Concluída": { icon: CheckCircle2, color: "#10B981", bg: "rgba(16,185,129,0.12)" },
  "Em andamento": { icon: Loader2, color: "#D4AF37", bg: "rgba(212,175,55,0.12)" },
  "Pendente": { icon: Circle, color: "#6B7280", bg: "rgba(107,114,128,0.12)" },
};

export default function Roadmap() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/inventory/roadmap").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-6" data-testid="roadmap-page">
      <div><h1 className="text-3xl font-display font-extrabold tracking-tight text-white">Roadmap do Alpha OS</h1>
        <p className="text-zinc-400 mt-1">Documentação viva das entregas · visível apenas para administradores.</p></div>
      <div className="grid gap-3">
        {items.map((it) => {
          const s = STYLE[it.status] || STYLE["Pendente"]; const Icon = s.icon;
          return (
            <div key={it.sprint} data-testid={`roadmap-${it.sprint}`} className="alpha-card p-5 flex items-center gap-4">
              <span className="h-10 w-10 rounded-xl flex items-center justify-center shrink-0" style={{ background: s.bg }}><Icon size={18} style={{ color: s.color }} className={it.status === "Em andamento" ? "animate-spin" : ""} /></span>
              <div className="flex-1"><div className="text-white font-semibold">{it.sprint} · {it.title}</div><div className="text-xs text-zinc-500">v{it.version}</div></div>
              <span className="text-xs px-3 py-1 rounded-full font-medium" style={{ background: s.bg, color: s.color }}>{it.status}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
